import { Link } from "react-router-dom";
import VerificationBadge from "./VerificationBadge";
import LastVerifiedDate from "./LastVerifiedDate";
import OfficialLinkButton from "./OfficialLinkButton";

export default function ComponentCard({ component }) {
  return (
    <article className="soft-card soft-card-hover flex h-full flex-col p-5 sm:p-6">
      <div className="flex items-start justify-between gap-4">
        <div><p className="text-xs font-black uppercase tracking-[0.16em] text-blue-700">{component.category}</p><h2 className="mt-2 text-2xl font-black text-neutral-950">{component.name}</h2></div>
        <VerificationBadge />
      </div>
      <p className="mt-2 text-sm font-bold text-neutral-500">Manufacturer {component.manufacturer}</p>
      <ul className="mt-4 grid gap-2 text-sm leading-6 text-neutral-600">
        {component.keySpecifications.slice(0, 3).map((spec) => <li key={spec} className="rounded-xl bg-neutral-50 px-3 py-2">{spec}</li>)}
      </ul>
      <div className="mt-4 flex flex-wrap gap-2">
        <span className="data-badge">{component.subcategory}</span><span className="data-badge">{component.country}</span>
      </div>
      <div className="mt-auto pt-6">
        <LastVerifiedDate date={component.lastVerified} />
        <div className="mt-4 flex flex-wrap gap-2">
          <Link className="btn-primary" to={`/robot-components/${component.slug}`}>View component details</Link>
          <OfficialLinkButton href={component.productPage} ariaLabel={`Visit the official ${component.name} product page`}>Official product page</OfficialLinkButton>
        </div>
      </div>
    </article>
  );
}
